module.exports = __webpack_public_path__ + "img/5.427ae4d2.jpg";